import { render, staticRenderFns } from "./Weekendshow.vue?vue&type=template&id=4729baf2&"
import script from "./Weekendshow.vue?vue&type=script&lang=js&"
export * from "./Weekendshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports